import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import update from 'react-addons-update'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

import Step1 from './AddCustomerStep1'
import Step2 from './AddCustomerStep2'

import AppStore from '../../../stores/AppStore'

function AddCustomer ({
  intl: { formatMessage, locale },
  data,
  previousPage,
  nextPage,
  page,
  currentData,
}) {
  const navigate = useNavigate()

  const [company, setCompany] = useState('')
  const [fromGroup, setFromGroup] = useState('')
  const [toGroup, setToGroup] = useState('')
  const [language, setLanguage] = useState(locale)
  const [invalid, setInvalid] = useState(false)
  const [saved, setSaved] = useState(false)
  const [shouldHide, setShouldHide] = useState(true)
  const [email, setEmail] = useState('')

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [])

  const handleChange = useCallback((field, value, callback) => {
    const newValue = value

    // Update the appropriate state based on field
    if (field === 'company') setCompany(newValue)
    if (field === 'fromGroup') setFromGroup(newValue)
    if (field === 'toGroup') setToGroup(newValue)
    if (field === 'language') setLanguage(newValue)
    if (field === 'invalid') setInvalid(newValue)
    if (field === 'saved') setSaved(newValue)
    if (field === 'shouldHide') setShouldHide(newValue)

    if (callback) callback()
  }, [])

  const step1Callback = useCallback((data) => {
    const emailData = data
    const includes = 'user_customers'
    AppDispatcher.dispatch({
      action: 'get-user-email',
      email: emailData,
      includes,
    })
    setEmail(emailData)
    nextPage()
  }, [nextPage])

  const backToUsers = useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()
    navigate(`/${customerID}/distributor/transferDevices`)
  }, [navigate])

  const unhide = useCallback(() => {
    setShouldHide(false)
  }, [])

  return (
    <div>
      {page === 1 &&
        (
          <Step1
            data={data}
            step1Callback={step1Callback}
            onSubmit={nextPage}
          />
        )}
      {page === 2 &&
        (
          <Step2
            data={data}
            previousPage={previousPage}
            step2Callback={step1Callback}
            email={email}
            currentData={currentData}
            onSubmit={nextPage}
          />
        )}
    </div>
  )
}

AddCustomer.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    locale: PropTypes.string,
  }),
  data: PropTypes.object,
  previousPage: PropTypes.func,
  nextPage: PropTypes.func,
  page: PropTypes.number,
  currentData: PropTypes.object,
}

export default injectIntl(AddCustomer)
